import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SystemsModuleState, SYSTEMS_MODULE_STATE_NAME } from './systems-module.state';

export const selectModuleState =
	createFeatureSelector<SystemsModuleState>(SYSTEMS_MODULE_STATE_NAME);

export const setModule = createSelector(selectModuleState, (form: SystemsModuleState) => form);
